import {StripeC2CRestService} from './restServices';
import storageService from '../storageService';

var service = {};

service.createStripeConnectedAccountByMentorId = async (mentorId, token) => {
  let requestObj = {
    mentorId,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await StripeC2CRestService.save(
    {
      endpoint: 'create-mentor-account',
    },
    requestObj,
  );
  return response.data;
};

service.connectExistingAccountByMentorId = async (
  mentorId,
  authCode,
  token,
) => {
  let requestObj = {
    mentorId,
    authCode,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await StripeC2CRestService.save(
    {
      endpoint: 'connect-existing-account',
    },
    requestObj,
  );
  return response.data;
};

service.updateStripeConnectedAccountByMentorId = async (
  mentorId,
  newStripeConnectedAccountId,
  token,
) => {
  let requestObj = {
    mentorId,
    newStripeConnectedAccountId,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await StripeC2CRestService.update(
    {
      endpoint: 'update-mentor-account',
    },
    requestObj,
  );
  return response.data;
};

service.reauthStripeConnectedAccountByMentorId = async (mentorId, token) => {
  let requestObj = {
    endpoint: 'reauth',
    mentorId,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await StripeC2CRestService.get(requestObj, requestObj);
  return response.data;
};

service.getStripeConnectedAccountStatusByMentorId = async (mentorId, token) => {
  const requestObject = {
    endpoint: 'status',
    mentorId,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await StripeC2CRestService.get(requestObject, requestObject);
  return response.data;
};

service.testStripePaymentIntent = async ({
  sessionTemplateId,
  paymentFlowType,
}) => {
  const requestObj = {
    sessionTemplateId,
    chatRoomId: 'DUMMY_CHAT_ROOM',
    paymentFlowType,
    payerUserId: 'DUMMY_TEST',
  };
  const response = await StripeC2CRestService.save(
    {
      endpoint: 'create-payment-intent',
    },
    requestObj,
  );
  return response.data;
};

service.createStripePaymentIntent = async ({
  sessionTemplateId,
  bookingFlowInstanceId,
  dynamicFormInstanceId,
  chatRoomId,
  paymentFlowType,
  payerUserId,
}) => {
  const requestObj = {
    sessionTemplateId,
    bookingFlowInstanceId,
    dynamicFormInstanceId,
    chatRoomId,
    paymentFlowType,
    payerUserId,
  };
  const response = await StripeC2CRestService.save(
    {
      endpoint: 'create-payment-intent',
    },
    requestObj,
  );
  return response.data;
};

const c2cStripeTransactionsService = {...service};

export default c2cStripeTransactionsService;
